module.exports = __webpack_public_path__ + "img/dealers_header3.efede424.png";